export function getCookie(cname) {
  const name = cname + "=";
  const decodedCookie = decodeURIComponent(document.cookie);
  const ca = decodedCookie.split(';');
  for(let i = 0; i <ca.length; i++) {
    let c = ca[i];
    while (c.charAt(0) === ' ') {
      c = c.substring(1);
    }
    if (c.indexOf(name) === 0) {
      return c.substring(name.length, c.length);
    }
  }
  return "";
}

export function redirectToSignin() {
  if (window.location.pathname === "/signin") {
    return;
  }

  const next = encodeURIComponent(
    window.location.pathname + window.location.search
  );

  window.location.assign(`/signin?next=${next}`);
}

// Must be a navigation rather than an XHR: axios attaches the Authorization
// header to every request, and S3 rejects a presigned URL that also carries
// one with "Only one auth mechanism allowed". The presigned link sets
// Content-Disposition: attachment, so the browser downloads without leaving
// the page.
export function downloadFromUrl(url) {
  window.location.assign(url);
}

export function setCookie(cname, cvalue, exdays) {
  const d = new Date();
  d.setTime(d.getTime() + (exdays*24*60*60*1000));
  const expires = "expires="+ d.toUTCString();
  document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
}
